import React from 'react';
import { GetServerSideProps } from 'next';

import {
  formatLanguageCodeInUrl,
  formatReqUrl,
  getCurrentRegion,
  getLanguageInURL,
  logSentryError,
} from '@source/utils/utils';
import { COOKIE_KEYS } from '@source/constants/common';
import { TLanguageKey, TRegionKey } from '@source/interface';
import AboutUs from '@source/pages/AboutUs';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const About = ({ region }: { region: TRegionKey }) => <AboutUs region={region} />;

export const getServerSideProps: GetServerSideProps = async ({ locale, req }) => {
  const cookieRegion = req.cookies?.[COOKIE_KEYS.STORED_REGION];
  const currentRegion = await getCurrentRegion({
    urlRegion: locale as TRegionKey,
    cookieRegion: cookieRegion as TRegionKey,
  });
  const urlLanguage = getLanguageInURL(formatReqUrl(req?.url as string, locale as TRegionKey));
  const lang = formatLanguageCodeInUrl(urlLanguage as TLanguageKey);

  if (!['jp', 'hk'].includes(currentRegion)) {
    logSentryError({
      region: locale as TRegionKey,
      errorMessage: 'About',
    });
    return {
      notFound: true,
    };
  }

  return {
    props: {
      region: currentRegion,
      lang,
      ...(await serverSideTranslations(lang)),
    },
  };
};

export default About;
